'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import UIHeader from 'UIComponents/layout/UIHeader';
import UILogo from 'UIComponents/image/UILogo';
import UITab from 'UIComponents/nav/UITab';
import UITabs from 'UIComponents/nav/UITabs';
import HeaderTabs from '../constants/HeaderTabs';
import { getRedirectToPurchases, isCustomer as getIsCustomer } from '../utils/utils';
import { getHeaderTabText } from '../utils/langUtils';
import { goToAllProducts, goToManagePurchases } from '../actions/GoodsActions';
import { managePurchasesPrefetcher } from '../prefetchers/managePurchasesPrefetcher';
var LOGO_SPACING = 16;
var StyledLogo = styled(UILogo).withConfig({
  displayName: "AppHeader__StyledLogo",
  componentId: "sc-1nw6g17-0"
})(["position:relative;top:-1px;margin-right:", "px;padding-right:", "px;height:1.2em;border-right:1px solid ", ";vertical-align:text-bottom !important;"], LOGO_SPACING, LOGO_SPACING, GREAT_WHITE);

var AppHeader = /*#__PURE__*/function (_Component) {
  _inherits(AppHeader, _Component);

  function AppHeader() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AppHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AppHeader)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handlePurchasedMouseEnter = function () {
      if (_this.props.isCustomer) {
        managePurchasesPrefetcher();
      }
    };

    _this.handleTabClick = function (event) {
      if (event.target.value === HeaderTabs.STOREFRONT) {
        _this.props.goToAllProducts();
      } else {
        if (_this.props.isCustomer) {
          _this.props.goToManagePurchases();
        } else {
          window.location = getRedirectToPurchases();
        }
      }
    };

    _this.renderTitle = function (isCustomer) {
      var title = React.createElement(FormattedMessage, {
        message: "header.title"
      });

      if (isCustomer) {
        return title;
      }

      return React.createElement("div", null, React.createElement(StyledLogo, {
        name: "hubspot-wordmark"
      }), title);
    };

    return _this;
  }

  _createClass(AppHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          currentTab = _this$props.currentTab,
          isCustomer = _this$props.isCustomer,
          searchBarComponent = _this$props.searchBarComponent;
      return React.createElement(Fragment, null, React.createElement(UIHeader, {
        tabs: React.createElement(UITabs, {
          defaultSelected: currentTab,
          onSelectedChange: this.handleTabClick
        }, React.createElement(UITab, {
          tabId: HeaderTabs.STOREFRONT,
          title: getHeaderTabText(HeaderTabs.STOREFRONT)
        }), React.createElement(UITab, {
          onMouseEnter: this.handlePurchasedMouseEnter,
          tabId: HeaderTabs.PURCHASED,
          title: getHeaderTabText(HeaderTabs.PURCHASED)
        })),
        title: this.renderTitle(isCustomer),
        use: "condensed"
      }, searchBarComponent && React.createElement("div", {
        className: "header-search-bar"
      }, searchBarComponent)));
    }
  }]);

  return AppHeader;
}(Component);

AppHeader.propTypes = {
  currentTab: PropTypes.string,
  goToAllProducts: PropTypes.func.isRequired,
  goToManagePurchases: PropTypes.func.isRequired,
  isCustomer: PropTypes.bool.isRequired,
  searchBarComponent: PropTypes.node
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isCustomer: getIsCustomer(state.auth.portal)
  };
};

var mapDispatchToProps = {
  goToAllProducts: goToAllProducts,
  goToManagePurchases: goToManagePurchases
};
export default connect(mapStateToProps, mapDispatchToProps)(AppHeader);